import React, { useState } from 'react';

const RealEstateAuction = () => {
  const [formData, setFormData] = useState({
    type: 'auction',
    region: '서울',
    pageNo: '1',
    numOfRows: '10'
  });
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  // 지역 옵션
  const regionOptions = [
    '서울', '부산', '대구', '인천', '광주', '대전', '울산', '세종',
    '경기', '강원', '충북', '충남', '전북', '전남', '경북', '경남', '제주'
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const params = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        if (value && value.trim() !== '') {
          params.append(key, value.trim());
        }
      });

      const response = await fetch(`/api/real-estate/auction?${params.toString()}`);
      const data = await response.json();

      if (data.success) {
        setResult(data);
      } else {
        setError(data.message || 'API 호출 실패');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatPrice = (price) => {
    if (!price) return '가격 정보 없음';
    return `${parseInt(price).toLocaleString()}만원`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return '날짜 정보 없음';
    return dateString.replace(/(\d{4})(\d{2})(\d{2})/, '$1년 $2월 $3일');
  };

  return (
    <div className="real-estate-auction">
      <div className="header">
        <h2>🏠 부동산 경매 정보</h2>
        <p>공공데이터포털을 통해 부동산 경매 정보를 조회합니다.</p>
      </div>

      <div className="control-section">
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="type">조회 유형:</label>
              <select
                id="type"
                name="type"
                value={formData.type}
                onChange={handleInputChange}
              >
                <option value="auction">경매 정보</option>
                <option value="bid">낙찰 정보</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="region">지역:</label>
              <select
                id="region"
                name="region"
                value={formData.region}
                onChange={handleInputChange}
              >
                {regionOptions.map(region => (
                  <option key={region} value={region}>
                    {region}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="numOfRows">결과 수:</label>
              <select
                id="numOfRows"
                name="numOfRows"
                value={formData.numOfRows}
                onChange={handleInputChange}
              >
                <option value="5">5개</option>
                <option value="10">10개</option>
                <option value="20">20개</option>
                <option value="50">50개</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="pageNo">페이지:</label>
              <input
                type="number"
                id="pageNo"
                name="pageNo"
                value={formData.pageNo}
                onChange={handleInputChange}
                min="1"
                max="100"
              />
            </div>
          </div>

          <button type="submit" disabled={loading}>
            {loading ? '조회 중...' : '🔍 경매 정보 조회'}
          </button>
        </form>
      </div>

      {error && (
        <div className="error-section">
          <h3>❌ 오류</h3>
          <p>{error}</p>
        </div>
      )}

      {result && (
        <div className="result-section">
          <div className="result-info">
            <h3>📊 조회 결과</h3>
            <p>
              지역: <strong>{result.region}</strong> | 
              유형: <strong>{result.type === 'auction' ? '경매 정보' : '낙찰 정보'}</strong> | 
              결과 수: <strong>{result.result.response?.body?.items?.item?.length || 0}</strong>개
            </p>
          </div>

          <div className="auction-grid">
            {result.result.response?.body?.items?.item ? (
              Array.isArray(result.result.response.body.items.item) ? (
                result.result.response.body.items.item.map((item, index) => (
                  <div key={index} className="auction-card">
                    <div className="auction-header">
                      <h4 className="auction-title">
                        {item.아파트 || item.단지명 || '부동산 정보'}
                      </h4>
                      <span className="auction-location">{item.법정동 || item.지역명}</span>
                    </div>
                    <div className="auction-details">
                      <p><strong>면적:</strong> {item.전용면적 || '정보 없음'}㎡</p>
                      <p><strong>층수:</strong> {item.층 || '정보 없음'}층</p>
                      <p><strong>거래일:</strong> {formatDate(item.년 || item.거래일)}</p>
                      <p><strong>거래금액:</strong> {formatPrice(item.거래금액)}</p>
                    </div>
                  </div>
                ))
              ) : (
                <div className="auction-card">
                  <div className="auction-header">
                    <h4 className="auction-title">
                      {result.result.response.body.items.item.아파트 || result.result.response.body.items.item.단지명 || '부동산 정보'}
                    </h4>
                    <span className="auction-location">{result.result.response.body.items.item.법정동 || result.result.response.body.items.item.지역명}</span>
                  </div>
                  <div className="auction-details">
                    <p><strong>면적:</strong> {result.result.response.body.items.item.전용면적 || '정보 없음'}㎡</p>
                    <p><strong>층수:</strong> {result.result.response.body.items.item.층 || '정보 없음'}층</p>
                    <p><strong>거래일:</strong> {formatDate(result.result.response.body.items.item.년 || result.result.response.body.items.item.거래일)}</p>
                    <p><strong>거래금액:</strong> {formatPrice(result.result.response.body.items.item.거래금액)}</p>
                  </div>
                </div>
              )
            ) : (
              <div className="no-data">
                <p>해당 지역의 경매 정보가 없습니다.</p>
              </div>
            )}
          </div>
        </div>
      )}

      <div className="info-section">
        <h3>ℹ️ 사용법</h3>
        <ul>
          <li><strong>조회 유형</strong>: 경매 정보 또는 낙찰 정보 선택</li>
          <li><strong>지역</strong>: 조회할 지역 선택 (전국 17개 시도)</li>
          <li><strong>결과 수</strong>: 한 번에 가져올 정보 개수 (최대 50개)</li>
          <li><strong>페이지</strong>: 페이지 번호 (페이지네이션용)</li>
        </ul>
        
        <h4>📋 API 제한사항</h4>
        <ul>
          <li>공공데이터포털 API 키 필요 (무료)</li>
          <li>일일 호출 제한: 1,000건 (무료)</li>
          <li>데이터 업데이트: 매월 초</li>
          <li>지역별 데이터 제공</li>
        </ul>

        <h4>🔗 API 키 발급 방법</h4>
        <ol>
          <li><a href="https://www.data.go.kr/" target="_blank" rel="noopener noreferrer">공공데이터포털</a> 접속</li>
          <li>회원가입 및 로그인</li>
          <li>"국토교통부 부동산 경매 정보" 검색</li>
          <li>API 키 신청 및 발급</li>
          <li>발급받은 키를 wrangler.toml에 설정</li>
        </ol>
      </div>
    </div>
  );
};

export default RealEstateAuction;

